import NextLink from 'next/link';
import { useTranslation } from 'react-i18next';
import styles from '../../HomepageSections.module.scss';
import { SectionHeading } from '../shared/SectionHeading';

export const ExpertiseSection = () => {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.expertiseSection}>
      <div className={styles.expertiseShell}>
        <div>
          <SectionHeading eyebrow={t('homepage.expertise.eyebrow')} title={t('homepage.expertise.title')} />
          <p>{t('homepage.expertise.description1')}</p>
          <p>{t('homepage.expertise.description2')}</p>
        </div>
        <div className={styles.regtechFamily}>
          <span>{t('homepage.expertise.familyLabel')}</span>
          <article>
            <div>
              <strong>eezi</strong>
              <p>{t('homepage.expertise.eeziDescription')}</p>
            </div>
            <b>{t('homepage.expertise.youAreHere')}</b>
          </article>
          <article>
            <NextLink
              className={styles.familyLink}
              href='https://vatit.com/compliance/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <strong>{t('homepage.expertise.complianceTitle')}</strong>
              <p>{t('homepage.expertise.complianceDescription')}</p>
            </NextLink>
          </article>
          <article>
            <NextLink
              className={styles.familyLink}
              href='https://vatit.com/reclaim/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <strong>{t('homepage.expertise.vatReclaimTitle')}</strong>
              <p>{t('homepage.expertise.vatReclaimDescription')}</p>
            </NextLink>
          </article>
          <small>{t('homepage.expertise.footer')}</small>
        </div>
      </div>
    </section>
  );
};
